import { CentreUnit } from '../types'

export const getSubTitleByUnit = (unit: CentreUnit): string => {
  return getSubTitle(unit.unitName, unit.unitId)
}

export const getSubTitle = (unitName: string, unitId: string): string => {
  return unitId
}
